import styled from 'styled-components';

export const StyledPrivacyPolicyWrapper = styled.div`
  cursor: default;
  padding: ${({ theme }) => theme.spacing['2Xl']};
  p {
    margin: 0;
    padding: 0;
    a {
      color: ${({ theme }) => theme.text.weak};
      ${({ theme }) => theme.body.link.xs}

      &:hover {
        cursor: default;
      }
    }
  }
`;
